import { createSlice, createAsyncThunk, createAction } from "@reduxjs/toolkit";
import customDesignService from "./customDesignService";

export const getCustomDesigns = createAsyncThunk(
  "custom-design/all",
  async (thunkAPI) => {
    try {
      return await customDesignService.getCustomDesigns();
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const deleteACustomDesign = createAsyncThunk(
  "custom-design/delete",
  async (id, thunkAPI) => {
    try {
      return await customDesignService.deleteCustomDesign(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getACustomDesign = createAsyncThunk(
  "custom-design/get",
  async (id, thunkAPI) => {
    try {
      return await customDesignService.getCustomDesign(id);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const updateACustomDesign = createAsyncThunk(
  "custom-design/edit",
  async (design, thunkAPI) => {
    try {
      return await customDesignService.updateCustomDesign(design);
    } catch (error) {
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const resetState = createAction("Reset_custom_design_all");

const initialState = {
  customDesigns: [],
  isError: false,
  isLoading: false,
  isSuccess: false,
  message: "",
};

export const customDesignSlice = createSlice({
  name: "customDesigns",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getCustomDesigns.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getCustomDesigns.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.customDesigns = action.payload.result;
      })
      .addCase(getCustomDesigns.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(deleteACustomDesign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(deleteACustomDesign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.deletedCustomDesign = action.payload;
      })
      .addCase(deleteACustomDesign.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(getACustomDesign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getACustomDesign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.designName = action.payload.name;
        state.designMobile = action.payload.mobile;
        state.designEmail = action.payload.email;
        state.designRemarks = action.payload.remarks;
        state.designImages = action.payload.images;
        state.designStatus = action.payload.status;
      })
      .addCase(getACustomDesign.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(updateACustomDesign.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateACustomDesign.fulfilled, (state, action) => {
        state.isLoading = false;
        state.isError = false;
        state.isSuccess = true;
        state.updatedCustomDesign = action.payload.result;
      })
      .addCase(updateACustomDesign.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
        state.isSuccess = false;
        state.message = action.error;
      })
      .addCase(resetState, () => initialState);
  },
});

export default customDesignSlice.reducer;
